const AppRoutes = {
  BUSINESS_CHOICE: '/business_choice',
  FLOW_CHOICE: '/flow_choice',
  ADDRESS_CHOICE: '/address_choice',
  ROOF_ANGLE: '/roof_angle',
  ROOF_TYPE: '/roof_type',
  PANEL_SELECTION: '/panel_selection',
  MAP_SYSTEM: '/orientation',
  CONSUMPTION: '/consumption',
  SME_CONTACT: '/sme_contact',
  BILL_INFO: '/consumption/bill',
  BILL_INFO_DEFAULT: '/consumption/bill/default',
  COUNTER: '/compteur',
  INVERTER: '/onduleur',
  BATTERY_OPTION: '/battery_option',
  ELECTRIC_VEHICLE: '/electric_vehicle',
  EXTRA_SERVICES: '/extra_services',
  SUMMARY: '/summary',
  THANKS: '/thanks',
  ESTIMATE: '/estimate',
};

export const HOME_ROUTE = AppRoutes.BUSINESS_CHOICE;

export default AppRoutes;
